import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import YouTubeIcon from "@mui/icons-material/YouTube";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import RoundedContentBox from "@/components/general/roundedContentBox";
import { getYouTubeWatchUrl } from "@/helper/youTubePlayerUtils";
import styles from "@/components/introVideo/introVideoCard.module.css";

interface IntroVideoCardProps {
  url: string;
}

export default function IntroVideoCard({ url }: IntroVideoCardProps) {
  const { t } = useTranslation();
  const watchUrl = getYouTubeWatchUrl(url);

  if (!watchUrl) {
    return null;
  }

  return (
    <a
      className={`dashboardNavlink ${styles.link}`}
      href={watchUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      <RoundedContentBox
        className={`dashboardClickableSurface ${styles.introVideoCard}`}
      >
        <span className={`dashboardStatIcon ${styles.icon}`} aria-hidden>
          <YouTubeIcon />
        </span>
        <div className={styles.text}>
          <h2 className={styles.heading}>{t("intro_video")}</h2>
          <Typography variant="body1">{t("intro_video_description")}</Typography>
        </div>
        <span className={styles.callToAction}>
          {t("intro_video_watch_on_youtube")}
          <OpenInNewIcon fontSize="small" aria-hidden />
        </span>
      </RoundedContentBox>
    </a>
  );
}
